"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Either = exports.right = exports.left = void 0;
const helpers_1 = require("./helpers");
const maybemonad_1 = require("./maybemonad");
function left(value) {
    if (value === null || value === undefined) {
        throw Error("Value must not be undefined or null!");
    }
    return new Either(value, undefined);
}
exports.left = left;
function right(value) {
    if (value === null || value === undefined) {
        throw Error("Value must not be undefined or null!");
    }
    return new Either(undefined, value);
}
exports.right = right;
class Either {
    get isLeft() { return (this._right === null || this._right === undefined); }
    get isRight() { return (this._left === null || this._left === undefined); }
    get left() {
        if (this.isLeft) {
            return this._left;
        }
        throw new Error("No left value");
    }
    get right() {
        if (this.isRight) {
            return this._right;
        }
        throw new Error("No right value");
    }
    get hasValue() { return this.isRight; }
    static flatten(coll) {
        return (0, helpers_1.flatten)(coll, Either.empty);
    }
    constructor(leftVal, rightVal) {
        this.unsafeLift = () => {
            if (this.isRight) {
                return this._right;
            }
            throw new Error("Is not a right value");
        };
        this.toMaybe = () => this.isRight ? new maybemonad_1.Just(this._right) : new maybemonad_1.Nothing();
        this.toPromise = () => this.isRight ? Promise.resolve(this._right) : Promise.reject(this._left);
        this.empty = () => Either.empty();
        if (leftVal !== undefined && rightVal !== undefined) {
            throw new Error("Can only set left or right to a defined value!");
        }
        this._left = leftVal;
        this._right = rightVal;
    }
    reduce(f, start) {
        if (this.isLeft) {
            return start;
        }
        return f(start, this._right);
    }
    map(f) {
        if (this.isLeft) {
            return left(this.left);
        }
        return right(f(this.right));
    }
    flatMap(f) {
        if (this.isLeft) {
            return left(this.left);
        }
        return f(this.right);
    }
    unit(x) {
        return right(x);
    }
    forEach(f) { if (this.isRight) {
        f(this._right);
    } }
    equals(that) {
        return (0, helpers_1.anyEquals)(this, that);
    }
    isEmpty() { return this.isLeft; }
}
exports.Either = Either;
Either.empty = () => left((0, maybemonad_1.nothing)());
//# sourceMappingURL=eithermonad.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/tsmonads/lib/src/eithermonad.js
// module id = 558
// module chunks = 0